import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import img from "./all_bg.jpg";

const BACKEND_URL = "https://api.bbsfacultyprofile.com";
const TABLE_NAME = "brand_membership";

const BrandMembership = () => {
  const navigate = useNavigate();

  const fieldLabels = {
    brand_name: "Company/Organization Name",
    industry: "Industry",
    country: "Country",
  };

  const [records, setRecords] = useState([]);

  const [formData, setFormData] = useState({
    starting_date: null,
    ending_date: null,
    role: "",
    brand_name: "",
    industry: "",
    country: "",
  });

  const [recordId, setRecordId] = useState(null);

  const [showCustomRole, setShowCustomRole] = useState(false);
  const [customRoleValue, setCustomRoleValue] = useState("");

  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    width: "100%",
    fontSize: "16px",
  };

  // ---------------- Fetch Records ----------------

  const fetchRecords = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/${TABLE_NAME}`, {
        method: "GET",
        credentials: "include",
      });

      if (!res.ok) throw new Error("Failed to fetch records");

      const data = await res.json();

      const processed = data
        .map((rec) => ({
          ...rec,

          // Store as Date objects for DatePicker
          starting_date: rec.starting_date
            ? new Date(rec.starting_date)
            : null,

          ending_date: rec.ending_date
            ? new Date(rec.ending_date)
            : null,
        }))
        .sort((a, b) => {
          if (!a.starting_date) return 1;
          if (!b.starting_date) return -1;

          // Latest month/year first
          return b.starting_date - a.starting_date;
        });

      setRecords(processed);
    } catch (err) {
      toast.error(`Fetch error: ${err.message}`);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  // ---------------- Input ----------------

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ---------------- Role ----------------

  const handleRoleChange = (e) => {
    const value = e.target.value;

    if (value === "Other") {
      setShowCustomRole(true);
      setCustomRoleValue("");
      setFormData({
        ...formData,
        role: "",
      });
    } else {
      setShowCustomRole(false);
      setCustomRoleValue("");
      setFormData({
        ...formData,
        role: value,
      });
    }
  };

  const handleCustomRoleChange = (e) => {
    setCustomRoleValue(e.target.value);

    setFormData({
      ...formData,
      role: e.target.value,
    });
  };

  // ---------------- Submit ----------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,

        starting_date: formData.starting_date
          ? `${formData.starting_date.getFullYear()}-${String(
              formData.starting_date.getMonth() + 1
            ).padStart(2, "0")}-01`
          : null,

        ending_date: formData.ending_date
          ? `${formData.ending_date.getFullYear()}-${String(
              formData.ending_date.getMonth() + 1
            ).padStart(2, "0")}-01`
          : null,
      };

      const url = recordId
        ? `${BACKEND_URL}/api/${TABLE_NAME}/${recordId}`
        : `${BACKEND_URL}/api/${TABLE_NAME}`;

      const method = recordId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to save record");

      toast.success("Record saved successfully!");

      setFormData({
        starting_date: null,
        ending_date: null,
        role: "",
        brand_name: "",
        industry: "",
        country: "",
      });

      setCustomRoleValue("");
      setShowCustomRole(false);
      setRecordId(null);

      fetchRecords();
    } catch (err) {
      toast.error(`Submit error: ${err.message}`);
    }
  };

  // ---------------- Edit ----------------

  const handleEdit = (rec) => {
    const isCustom =
      rec.role && !["Chairman", "Member"].includes(rec.role);

    setShowCustomRole(isCustom);
    setCustomRoleValue(isCustom ? rec.role : "");

    setFormData({
      starting_date: rec.starting_date,
      ending_date: rec.ending_date,
      role: rec.role,
      brand_name: rec.brand_name || "",
      industry: rec.industry || "",
      country: rec.country || "",
    });

    setRecordId(rec.id);

    toast.info("Editing record...");
  };

  // ---------------- Delete ----------------

  const handleDelete = (record) => {
    const toastId = toast.info(
      <div>
        Delete this record?
        <button
          onClick={async () => {
            try {
              const res = await fetch(
                `${BACKEND_URL}/api/${TABLE_NAME}/${record.id}`,
                {
                  method: "DELETE",
                  credentials: "include",
                }
              );

              if (!res.ok)
                throw new Error("Failed to delete record");

              fetchRecords();

              toast.update(toastId, {
                render: "Record deleted successfully!",
                type: "success",
                autoClose: 3000,
              });
            } catch (err) {
              toast.update(toastId, {
                render: `Delete error: ${err.message}`,
                type: "error",
                autoClose: 3000,
              });
            }
          }}
          style={{
            marginLeft: "10px",
            padding: "3px 8px",
            background: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Confirm
        </button>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
      }
    );
  };return (
  <div
    style={{
      minHeight: "100vh",
      padding: "40px 20px",
      fontFamily: "Arial, sans-serif",
      backgroundImage: `url(${img})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
    }}
  >
    <ToastContainer position="top-center" autoClose={3000} />

    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        background: "#fff",
        padding: "30px 40px",
        borderRadius: "10px",
        boxShadow: "0px 0px 12px rgba(0,0,0,0.1)",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: "#1e3a8a",
          marginBottom: "25px",
        }}
      >
        Board Memberships
      </h2>

      <form
        style={{ display: "flex", flexDirection: "column" }}
        onSubmit={handleSubmit}
      >
        {/* Dates */}
        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: "bold" }}>
              Starting Month/Year (mm/yyyy)
            </label>

            <DatePicker
              selected={formData.starting_date}
              onChange={(date) =>
                setFormData({
                  ...formData,
                  starting_date: date,
                })
              }
              dateFormat="MM/yyyy"
              showMonthYearPicker
              placeholderText="Select month/year"
              className="form-control"
            />
          </div>

          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: "bold" }}>
              Ending Month/Year (mm/yyyy)
            </label>

            <DatePicker
              selected={formData.ending_date}
              onChange={(date) =>
                setFormData({
                  ...formData,
                  ending_date: date,
                })
              }
              dateFormat="MM/yyyy"
              showMonthYearPicker
              placeholderText="Select month/year"
              className="form-control"
            />
          </div>
        </div>

        {/* Role */}
        <div style={{ marginTop: "15px" }}>
          <label style={{ fontWeight: "bold" }}>
            Role
          </label>

          <select
            name="role"
            value={showCustomRole ? "Other" : formData.role}
            onChange={handleRoleChange}
            style={inputStyle}
            required
          >
            <option value="">Select Role</option>
            <option value="Chairman">Chairman</option>
            <option value="Member">Member</option>
            <option value="Other">Other</option>
          </select>

          {showCustomRole && (
            <input
              type="text"
              placeholder="Enter role"
              value={customRoleValue}
              onChange={handleCustomRoleChange}
              style={{
                ...inputStyle,
                marginTop: "8px",
              }}
              required
            />
          )}
        </div>

        {/* Other Fields */}
        {["brand_name", "industry", "country"].map((field) => (
          <div
            key={field}
            style={{ marginTop: "15px" }}
          >
            <label style={{ fontWeight: "bold" }}>
              {fieldLabels[field]}
            </label>

            <input
              type="text"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              style={inputStyle}
              required
            />
          </div>
        ))}

        <button
          type="submit"
          style={{
            background: "#3b82f6",
            color: "white",
            padding: "12px",
            border: "none",
            borderRadius: "6px",
            marginTop: "20px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {recordId ? "Update Record" : "Add Record"}
        </button>
      </form>
      {/* ---------------- Records Table ---------------- */}
{records.length > 0 && (
  <div style={{ marginTop: "30px", overflowX: "auto" }}>
    <h3 style={{ color: "#1e3a8a" }}>Your Records</h3>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
      }}
    >
      <thead>
        <tr>
          {[
            "Starting Date",
            "Ending Date",
            "Role",
            fieldLabels.brand_name,
            fieldLabels.industry,
            fieldLabels.country,
            "Actions",
          ].map((h) => (
            <th
              key={h}
              style={{
                border: "1px solid #ccc",
                padding: "8px",
                background: "#f1f5f9",
              }}
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {records.map((rec) => (
          <tr key={rec.id}>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              {rec.starting_date
                ? `${String(rec.starting_date.getMonth() + 1).padStart(
                    2,
                    "0"
                  )}/${rec.starting_date.getFullYear()}`
                : ""}
            </td>

            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              {rec.ending_date
                ? `${String(rec.ending_date.getMonth() + 1).padStart(
                    2,
                    "0"
                  )}/${rec.ending_date.getFullYear()}`
                : ""}
            </td>

            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              {rec.role}
            </td>

            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              {rec.brand_name}
            </td>

            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              {rec.industry}
            </td>

            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              {rec.country}
            </td>

            <td
              style={{
                border: "1px solid #ccc",
                padding: "8px",
                textAlign: "center",
              }}
            >
              <button
                onClick={() => handleEdit(rec)}
                style={{
                  background: "#2563eb",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  marginRight: "5px",
                  cursor: "pointer",
                }}
              >
                Edit
              </button>

              <button
                onClick={() => handleDelete(rec)}
                style={{
                  background: "#ef4444",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

<div style={{ textAlign: "center", marginTop: "25px" }}>
  <button
    onClick={() => navigate("/dashboard")}
    style={{
      background: "#1e3a8a",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      fontWeight: "bold",
    }}
  >
    Back to Dashboard
  </button>
</div>

</div>
</div>
);

};

export default BrandMembership;